import React from 'react';
import './ForgetPassword.scss';
import LoginBg from 'assets/images/loginbg.jpg';
import LoginReglogo from 'assets/images/logo.png';
import { useTranslation } from 'react-i18next';
function ForgetPassword() {
	const { t } = useTranslation();
	return (
		<>
			<section className="login-regbg d-flex align-items-center justify-content-center" style={{ background: `url(${LoginBg})` }}>
				<div className="login-reg-wrap">
					<div className="login-reg-box">
						<span className="log-reg-logo">
							<img className="img-block" src={LoginReglogo} alt="LoginReglogo" />
						</span>
						<div className="login-input">
							<label className="lbl-heading">{t('admin_user.email')}</label>
							<input type="text" className="form-control login-input-style" placeholder={t('checkout_page.enter_your_email')} />
						</div>
						<div className="logreg-btn-wrap">
							<button type="submit" className="logreg-btn">
								{t('data_obser.send_otp')}
							</button>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default ForgetPassword;
